import axios from 'axios';

import { headers, STOCK } from '../../config';

export function searchMeasureUnits(data) {
    return axios.get(`${STOCK}/measure-units`, { headers: headers(), params: data })
}

export function getMeasureUnit({id}) {
    return axios.get(`${STOCK}/measure-units/${id}`, { headers: headers() })
}

export function createMeasureUnit(data) {
    return axios.post(`${STOCK}/measure-units`, data, { headers: {...headers(), "X-Request-ID": data.idempotentKey } });
}

export function updateMeasureUnit(data) {
    return axios.put(`${STOCK}/measure-units/${data.id}`, data, {headers: headers()})
}

export function deleteMeasureUnit({id}) {
    return axios.delete(`${STOCK}/measure-units/${id}`, {headers: headers()})
}